<template>
  <div class="appNoData">
    <img class="noDataHintImg" src="@/assets/暂无数据@2x.png" />
    <p class="noDataHintSpan">暂无数据</p>
  </div>
</template>

<script>
export default {
  props: {
    data: {},
  },
};
</script>

<style lang="less" scoped>
.appNoData {
  width: 100%;
  height: 100%;

  .noDataHintImg {
    margin-left: calc(50% - 200px);
    margin-top: 10%;
    width: 400px;
    // height: 100px;
  }

  .noDataHintSpan{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    height: 30px ;
    text-align: center;
    width: 100% ;
    padding: 0;
    margin: 20px 0 0 0;
  }
}
</style>
